import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useDelete = () => {
  const { mutate: deletePlan, isPending } = useIdempotentAppMutation(
    [QueryKey.TERMINATE_SHARE_PLAN],
    {
      mutationFn: ({ companyId, planId }: { companyId: string; planId: string }, { headers }) =>
        ApiService.delete(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'share-plans', planId],
          },
          { headers },
        ),
    },
  );
  return { deletePlan, isPending };
};
